
window.addEventListener("turbolinks:load", () => {
    const links = document.querySelectorAll(
      "a[data-skin-color]"
    );
    links.forEach((element) => {
      element.addEventListener("click", (event) => {
        event.preventDefault();
        const {skinColor} = element.dataset;
        $('#profile_skin_color').attr('value', skinColor);

        $.ajax({
          url: "/mynails/profile/update",
          method: "PUT",
          dataType: "html",
          data: {skin_color: skinColor},
          error: function (xhr, status, error) {
            console.error('AJAX Error: ' + status + error);
          },
          success: function (response) {
            const updated_skin_color = document.querySelector('#skin_color')
            updated_skin_color.innerHTML = response;

            selected_product = document.getElementById("product_id");
            if (selected_product !== null) {

              method: 'GET',
              $.ajax({
                url: "/mynails/my_colors/" + selected_product.value,
                method: "GET",
                credentials: "include",
                dataType: "script",
                dataType: "html",
                headers: {
                  "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content 
                },
                error: function (xhr, status, error) {
                  console.error('AJAX Error: ' + status + error);
                },
                success: function (response) {
                  var targetElement = document.getElementById("update_selected_swatch");
                  targetElement.innerHTML = response;
                  initToolTips(); // Initialize tooltips after new content is added
                }
              });
            }              

          }
        });

      });
    });

    const links2 = document.querySelectorAll(
        "a[data-hair-color]"
      );
      links2.forEach((element) => {
        element.addEventListener("click", (event) => {
          event.preventDefault();
          const {hairColor} = element.dataset;
          $('#profile_hair_color').attr('value', hairColor);
  
          $.ajax({
            url: "/mynails/profile/update",
            method: "PUT",
            dataType: "html",
            data: {hair_color: hairColor},
            error: function (xhr, status, error) {
              console.error('AJAX Error: ' + status + error);
            },
            success: function (response) {
              const updated_hair_color = document.querySelector('#hair_color')
              updated_hair_color.innerHTML = response;

              selected_product = document.getElementById("product_id");
              if (selected_product !== null) {
  
                method: 'GET',
                $.ajax({
                  url: "/mynails/my_colors/" + selected_product.value,
                  method: "GET",
                  credentials: "include",
                  dataType: "script",
                  dataType: "html",
                  headers: {
                    "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content 
                  },
                  error: function (xhr, status, error) {
                    console.error('AJAX Error: ' + status + error);
                  },
                  success: function (response) {
                    var targetElement = document.getElementById("update_selected_swatch");
                    targetElement.innerHTML = response;
                    initToolTips(); // Initialize tooltips after new content is added
                  }
                });
              }          

            }
          });
  
        });
      });

  });